import { REGEX_EMAIL } from '@/configuration/regexConf';

export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('RELANCE_ONLY_ONE_PAYER') === 0) {
      messages.push({
        message: 'addNewRelance.messageError',
      });
    }
    if (message.indexOf('RELANCE_CANNOT_DEACTIVATED') === 0) {
      messages.push({
        message: 'relanceSave.messages.errors.relanceCannotBeDeactived',
      });
    }
    if (message.indexOf('RELANCE_INVOICES_CANNOT_DUNNED') === 0) {
      const codes = message.split('|')[0].split('@')[1];
      messages.push({
        message: codes.include(', ') ? 'addNewRelance.facturesNonRelancable' : 'addNewRelance.factureNonRelancable',
        parametres: { codes, code: codes },
      });
    }
  });
}

export function validationMail(mail, messages) {
  if (mail.objet?.length === 0) {
    messages.push({ message: 'relance.envoiMailMasse.error.objectRequired' });
  }
  if (mail.corps?.length === 0) {
    messages.push({ message: 'relance.envoiMailMasse.error.corpsRequired' });
  }
  if (mail.from?.length === 0) {
    messages.push({ message: 'relance.envoiMailMasse.error.fromRequired' });
  }
  if (mail.to?.length === 0) {
    messages.push({ message: 'relance.envoiMailMasse.error.toRequired' });
  }
  if (mail.to?.some(m => !REGEX_EMAIL.test(m))) {
    messages.push({ message: 'relance.envoiMailMasse.error.formatEmail' });
  }
  const cleanEmails = (emails) => emails.map(m => m.email || m);
  const destinataires = cleanEmails(mail.to);
  if (cleanEmails(mail.cci).some(m => cleanEmails(mail.to).includes(m))) {
    messages.push({ message: 'relance.envoiMailMasse.error.alreadyInCopy' });
  }
  const uniqueDestinataire = [...new Set(destinataires)];
  if (destinataires.length !== uniqueDestinataire.length) {
    messages.push({ message: 'relance.envoiMailMasse.error.dupplicateMail' });
  }
}
